import { render, staticRenderFns } from "./Redirection.vue?vue&type=template&id=3c827179&scoped=true&"
import script from "./Redirection.vue?vue&type=script&lang=js&"
export * from "./Redirection.vue?vue&type=script&lang=js&"
import style0 from "./Redirection.vue?vue&type=style&index=0&id=3c827179&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c827179",
  null
  
)

export default component.exports